import React, {useState, useEffect} from 'react';
import {customStyle} from './FooterStyles';
import {properties as appProperties} from '../../../AppData'
import {useHistory} from "react-router-dom";
import axios from 'axios';
import {properties as propertiesCloudConfig } from '../../../config/Config';
import RestProvider from 'providers/RestProvider';
import AuthProvider from 'providers/authProvider';
import {mockFooterBottom} from './FooterData';
import { Link } from '@material-ui/core';

const COLUMN_TYPE_RRSS = 'RRSS';
const WEB_RIGHTS_1 = 'accesibilidad';
const RRSS_TITLE_LINK = 'Síguenos en ';
const RRSS_ICON_PATH = 'images/RRSS/';
const RESOURCE = 'footer';
const COLUMN_LABEL_RRSS = 'Síguenos en:'

function Footer() {

  const {crudOperation, crudOperationsType} = RestProvider();
  const {checkCloudProperties} = AuthProvider();
  const [mainColumnList, setMainColumnList] = useState([]);
  const [isPhoneVersion, setIsPhoneVersion] = useState(false);
  const [bloqueInferior, setBloqueInferior] = useState();
  const [isFromApi, setIsFromApi] = useState(true);
  const styles = customStyle()
  const history = useHistory();
  
  useEffect(() => {
      getData();
      updateFormat();
  }, []) ;

  const getData = async () => {
    await checkCloudProperties(100);
    let url = propertiesCloudConfig['URL_API_FOOTER'];
    
    if(url){
      let dataObtenerRecursoApiGrafica = {'url' :  url}
      crudOperation(crudOperationsType.CUSTOM, RESOURCE, { url: 'obtenerRecursoApiGrafica', method: 'post', data: dataObtenerRecursoApiGrafica}).then(function(response){
        montarDatosFooterTop(response.data.contenidoHtml);
        montarDatosFooterBottom(response.data.contenidoHtml);
      }).catch(function (err) {
        crudOperation(crudOperationsType.CUSTOM, RESOURCE, { url: '', method: 'get'})
        .then(response =>{
          setMainColumnList(response.data.mainColumns);
        });
        setIsFromApi(false);
        setBloqueInferior(mockFooterBottom);
      });
    }else{
      crudOperation(crudOperationsType.CUSTOM, RESOURCE, { url: '', method: 'get'})
      .then(response =>{
        setMainColumnList(response.data.mainColumns);
      });
      setIsFromApi(false);
      setBloqueInferior(mockFooterBottom);
    }
  }

  ////////////////////////////////////////////////////////////

  const montarDatosFooterTop = (datos) => {
    let response = [];

    //Pasar datos de string a html
    var div = document.createElement('div');
    div.innerHTML = datos;

    //Parte superior del footer
    let datosColumnas = div.getElementsByClassName("site-footer__top");
    if(datosColumnas && datosColumnas[0]){

      //MAIN COLUMN
      let columnasPrincipales = datosColumnas[0].getElementsByTagName("section");
      for (let indexColumnaPrincipal in columnasPrincipales){ 
        let columnaPrincipal = columnasPrincipales[indexColumnaPrincipal];
        if(columnaPrincipal instanceof HTMLElement){
          //COLUMNAS
          let objetoColumnasRespuesta = [];

          let columnas = columnaPrincipal.getElementsByClassName("block");
          for (let indexColumna in columnas){ 
            let columna = columnas[indexColumna];
            if(columna instanceof HTMLElement){

              //Titulo columna
              // Es posible que la etiqueta className que contien el título pueda ser node__title o title
              let tituloElemento = columna.getElementsByClassName('node__title').length === 0 ? columna.getElementsByClassName('title') : columna.getElementsByClassName('node__title');
              let titulo = tituloElemento.length !== 0 && tituloElemento[0].textContent;

              //Tipo columna
              let tipoColumna = "NORMAL";
              if(columna.classList.contains("redes-sociales")){
                tipoColumna="RRSS"
              }

              //FILAS
              let objetoFilasRespuesta = [];

              let elementosFilas = columna.getElementsByTagName('a');
              for (let indexFila in elementosFilas){ 
                let fila =  elementosFilas[indexFila];
                if(fila instanceof HTMLElement){
              
                  //Texto fila
                  let texto = "";
                  if(tipoColumna==="RRSS"){
                    if(fila.hasChildNodes && fila.childNodes[1]){
                      let clase = fila.childNodes[1].className;
                      let indexInicio = clase.indexOf("fa-");
                      if(indexInicio!==-1){
                        let indexFinal = clase.indexOf(" ", indexInicio);
                        clase.substring(indexInicio, indexFinal!==-1? indexFinal : clase.length);
                        texto = clase.substring(indexInicio+3, indexFinal!==-1? indexFinal : clase.length);
                      } 
                    }
                    
                  }else{
                    texto = fila.getAttribute("title");
                  }
                  
                  //Enlace fila
                  let enlace = fila.getAttribute("href");

                  //Guardar fila
                  if (texto !== undefined && texto !== null && texto.toLowerCase() !== "mapa web") {
                    objetoFilasRespuesta.push({
                      "text": texto,
                      "link": enlace
                    });
                  } else if (texto === undefined || texto === null) {
                    objetoFilasRespuesta.push({
                      "link": enlace
                    });
                  } 
                } 
              }
              //Guardar columna
              objetoColumnasRespuesta.push(
                { 
                  "label": titulo,
                  "columnType": tipoColumna,         
                  "rows": objetoFilasRespuesta
                }
              )
            } 
          };
          //Guardar columna principal
          response.push(
            {
              "columns": objetoColumnasRespuesta          
            }
          );  
        } 
      }
    }
    setMainColumnList(response);
  }

  ////////////////////////////////////////////////////////////

  const montarDatosFooterBottom = (datos) => {

    let response = {};

    //Pasar datos de string a html
    var div = document.createElement('div');
    div.innerHTML = datos;

    //Parte inferior del footer
    let datosParteInferior = div.getElementsByClassName("site-footer__bottom");
    if(datosParteInferior && datosParteInferior[0]){

      //ENLACES
      let bloqueEnlaces = datosParteInferior[0].getElementsByClassName("enlace-footer-custom");
      if(bloqueEnlaces && bloqueEnlaces[0]){
        let listadoEnlaces = [];
        let enlaces = bloqueEnlaces[0].getElementsByTagName('a');

        for (let index = 0; index < enlaces.length; index++) {
          const enlace = enlaces[index];
          let texto = enlace.textContent;
          let link = enlace.getAttribute("href");
          listadoEnlaces.push(
            {
              texto: texto,
              link: link
            }
          )        
        }
        response.enlaces = listadoEnlaces;
      }
    }

    //ICONOS
    let bloqueIconos = datosParteInferior[0].getElementsByClassName("logo-footer");
    let logoUcrania = datosParteInferior[0].querySelector("#block-quicknodeblock-115");

    let iconos = [];
    for (const icon of bloqueIconos) {
      iconos.push(icon);
    }
    iconos.push(logoUcrania);
    
    if(iconos){
      let listadoIconos = [];
      for (let index = 0; index < iconos.length; index++){
        let image = iconos[index].getElementsByTagName('img');
        if(image){
          let alt = image[0].getAttribute('alt');
          let src = image[0].getAttribute('data-src');
          if(!src){
            src = image[0].getAttribute('src');
          }

          listadoIconos.push(
            {
              alt: alt,
              src: src
            }
          );
        }
      }
      response.iconos = listadoIconos;
    }

    setBloqueInferior(response)
  }

  ////////////////////////////////////////////////////////////

  const renderColumnRows = (column) =>{
    let rowList = column.rows;

    if(column.label === COLUMN_LABEL_RRSS){
      const redesSociales = ['twitter', 'instagram', 'facebook', 'linkedin', 'youtube', 'flickr'];

      const getIconoFromLink = (row, redesSociales) => {
        let altText = null;
          for (const rs of redesSociales) {
            if (row.link.includes(rs)) {
              altText = rs;
              break;
            }
          }
        return altText;
      }

      return <div className={styles.footerRrssItemsWrapper}>{        

        rowList && rowList.map((row) =>{
          let altText = getIconoFromLink( row, redesSociales);
          return <a target="_blank" href={row.link} title={RRSS_TITLE_LINK + altText} className={styles.colFooterRRSS}><img className= {styles.rrssIcons} src={RRSS_ICON_PATH + altText.toLowerCase() + ".svg"} alt={altText}/></a>
        })
      }
      </div>

    }else{
      return <ul className={styles.footerList}> {rowList && rowList.map((row) =>{
            if((row.text ? row.text.toLowerCase() : '') === "contacto"){
              return <li className={styles.footerColumnLi}><Link onClick={()=>history.push("/PantallaContacto")} className={styles.colFooter}>{row.text}</Link></li>
            }else{
              return <li className={styles.footerColumnLi}><a target="_blank" href={row.link} className={styles.colFooter}>{row.text}</a></li>
            }           
          })}
      </ul>
         
    }
  }

  ////////////////////////////////////////////////////////////

  const renderGrid = () =>{
    
    return mainColumnList && mainColumnList.map((columnList) => {
      return <div className={styles.footerMainColumn}>{

        columnList.columns.map((column) =>{
      
          return <div className={styles.footerColumn}>
            <h2 className={styles.colFooterTittle}>{column.label}</h2>{renderColumnRows(column)}
          </div>
        })
        
      }</div>
    });
  }

  ////////////////////////////////////////////////////////////

  const onClickAccesibilidad = () => {
    history.push('/Accesibilidad');  
}

  const renderBottomPart = () =>{

    return <div className={!isPhoneVersion ? styles.bottomSectionWrap : styles.bottomSectionWrapPhone}>

      {/*ICONOS*/}
      <div className={!isPhoneVersion ? styles.bottomSectionLogos : styles.bottomSectionLogosPhone}>
        {bloqueInferior && bloqueInferior.iconos && bloqueInferior.iconos.map((icono)=>{
          let estilo;
          if(isPhoneVersion){
            estilo = isFromApi ? styles.jaLogoPhone : styles.jaLogoPhoneMock;
          }else{
            estilo = isFromApi ? styles.jaLogo : styles.jaLogoMock;
          }
          return (
            <img className={estilo} src={icono.src} alt={icono.alt}/>
          );
        })}
      </div>

      {/*ENLACES*/}
      <div className={!isPhoneVersion ? styles.websiteRightsWrapper : styles.websiteRightsWrapperPhone}>
        {bloqueInferior && bloqueInferior.enlaces && bloqueInferior.enlaces.map((enlace)=>{
          return (
            enlace.texto.toLowerCase() !== WEB_RIGHTS_1 ?
              <a target="_blank" href={enlace.link} className={styles.websiteRights} title={enlace.texto}>{enlace.texto}</a>
            :
              <a onClick={onClickAccesibilidad} className={styles.websiteRights} title={enlace.texto}>{enlace.texto}</a>
          );
        })}
      </div>

    </div>
  }

  ////////////////////////////////////////////////////////////

  /**Salto a versión movil*/
  const updateFormat = () => {
    if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
      setIsPhoneVersion(true);
    } else {
      setIsPhoneVersion(false);
    }
  };

  window.addEventListener('resize', updateFormat);
  ////////////////////////////////////////////////////////////

  return (

    <footer className={styles.footerContainer}>

      <div className={mainColumnList.length===0 ? styles.footerGridEmpty : styles.footerGrid} >
        
        <div className={!isPhoneVersion ? styles.footerGridWrapper : styles.footerGridWrapperPhone}>
          {renderGrid()}
        </div>
      </div>

      <section className={styles.bottomSection}>
        {renderBottomPart()}
      </section>

    </footer>
    
  );
}

export default Footer;
